module.exports = require("@ember/array");